export const HOME_SURFACES = {
  hero: 'home-hero',
  ivory:
    'home-surface-ivory py-16 md:py-24 border-y border-[var(--ir-line)]/80',
  parchment:
    'home-surface-parchment py-16 md:py-24 border-y border-[var(--ir-line)]/80',
  deep: 'home-surface-deep py-16 md:py-24 text-white overflow-hidden relative',
} as const;
